import cnf from "../config.json";

/**
 * utils for get config
 */
export default class ConfigGetter {
    static getConfig () {
        switch (process.env.REACT_APP_HOST_ENV) {
            case "production":
                const base_url = window.location.href.split("/")[2].split(":")[0];
                if (JSON.stringify(cnf["production"]).includes("base_url")) {
                    Object.keys(cnf["production"]).forEach(k => {
                        cnf["production"][k] = cnf["production"][k].replace("base_url", base_url);
                    });
                }
                return cnf["production"];
            case "staging":
                return cnf["staging"];
            case "localhost":
            case "development":
            default:
                const env = process.env.REACT_APP_HOST_ENV;
                const original_base_url = window.location.href.split("/")[2].split(":")[0];
                Object.keys(cnf[env]).forEach((k) => {
                    cnf[env][k] = cnf[env][k].replace("localhost", original_base_url);
                });
                return cnf[env];
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/ConfigGetter.js